/**
 * Central design tokens for the advisor app. Structure mirrors the applicant
 * app so token names carry the same semantic meaning across both codebases.
 * Values are tuned for desktop density.
 */

export const labels = {
  // Tier 1: Top-level yes/no screening questions
  question: "text-[11px] uppercase tracking-wide font-medium text-slate-500",

  // Tier 2: Group header (CUSTOMER DETAILS, CASE METADATA)
  groupHeader: "text-[12px] font-semibold text-slate-700 uppercase tracking-wider",

  // Tier 3: Individual field label (First name, Province, Nationality)
  field: "text-[11px] uppercase tracking-wide font-medium text-slate-500",

  // Quiet supporting label above a read-only value
  cardLabel: "text-[11px] text-slate-500 uppercase tracking-wide",

  // Value display in card (read-only state)
  cardValue: "text-[14px] text-slate-900",

  // Optional pill next to a field label
  optionalPill: "text-[10px] text-slate-500 bg-slate-50 border border-slate-100 rounded-full px-2 py-0.5",
};

export const inputs = {
  base: "w-full h-9 px-2.5 bg-white rounded-lg text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-300 transition-all",
  borderDefault: "border border-slate-200",
  borderFilled: "border border-emerald-400",
  borderError: "border border-rose-400",
  borderNeedsAttention: "border border-amber-300 bg-amber-50",
};
